export type HealthStatus = 'on_maintenance';

export interface Health {
  id?: string;
  status: HealthStatus | { value: HealthStatus };
}

export const isOnMaintenance = (health: Health | null | undefined): boolean => {
  if (!health) {
    return false;
  }
  const status = health.status;
  return typeof status === 'object' && 'value' in status
    ? status.value === 'on_maintenance'
    : status === 'on_maintenance';
};

